module.exports = __webpack_public_path__ + "img/gh.0536bfe2.png";